export const courses = [
  {
    title: 'Montag',
    id: 'Montag',
    options: [
      {
        id: '1800-1930',
        label: '18:00 - 19:30',
      },
      {
        id: '1940-2110',
        label: '19:40 - 21:10',
      },
    ],
  },
  {
    title: 'Dienstag',
    id: 'Dienstag',
    options: [
      {
        id: '1800-1930',
        label: '18:00 - 19:30',
      },
      {
        id: '1940-2110',
        label: '19:40 - 21:10',
      },
    ],
  },
  {
    title: 'Mittwoch',
    id: 'Mittwoch',
    options: [
      {
        id: '1830-2000',
        label: '18:30 - 20:00',
      },
    ],
  },
  {
    title: 'Donnerstag',
    id: 'Donnerstag',
    options: [
      {
        id: '1800-1930',
        label: '18:00 - 19:30',
        sublabel: '(auf Russisch)',
      },
      {
        id: '1940-2110',
        label: '19:40 - 21:10',
      },
    ],
  },
  {
    title: 'Freitag',
    id: 'Freitag',
    options: [
      {
        id: '1000-1130',
        label: '10:00 - 11:30',
      },
      {
        id: '1630-1800',
        label: '16:30 - 18:00',
        sublabel: '(Hatha Yoga bei Ina)',
      },
      {
        id: '1830-2000',
        label: '18:30 - 20:00',
      },
    ],
  },
]

export const courseTimes = [
  {
    title: 'Montagskurs',
    id: 'Montagskurs',
    for: 'Montag',
    options: [
      {
        id: '05.01. - 16.03. | 10 x 90min | 130€',
        label: '05.01. - 16.03. | 10 x 90min | 130€',
      },
      {
        id: '13.04. - 29.06. | 11 x 90min | 154€',
        label: '13.04. - 29.06. | 11 x 90min | 154€',
      },
      {
        id: '24.08. - 09.11. | 10 x 90min | 140€',
        label: '24.08. - 09.11. | 10 x 90min | 140€',
      },
      {
        id: '16.11. - 14.12. | 5 x 90min | 70€',
        label: '16.11. - 14.12. | 5 x 90min | 70€',
      },
    ],
  },
  {
    title: 'Dienstagskurs',
    id: 'Dienstagskurs',
    for: 'Dienstag',
    options: [
      {
        id: '06.01. - 17.03. | 10 x 90min | 130€',
        label: '06.01. - 17.03. | 10 x 90min | 130€',
      },
      {
        id: '14.04. - 30.06. | 11 x 90min | 154€',
        label: '14.04. - 30.06. | 11 x 90min | 154€',
      },
      {
        id: '25.08. - 10.11. | 10 x 90min | 140€',
        label: '25.08. - 10.11. | 10 x 90min | 140€',
      },
      {
        id: '17.11. - 15.12. | 5 x 90min | 70€',
        label: '17.11. - 15.12. | 5 x 90min | 70€',
      },
    ],
  },
  {
    title: 'Mittwochskurs',
    id: 'Mittwochskurs',
    for: 'Mittwoch',
    options: [
      {
        id: '07.01. - 11.03. | 10 x 90min | 130€',
        label: '07.01. - 11.03. | 10 x 90min | 130€',
      },
      {
        id: '08.04. - 01.07. | 13 x 90min | 182€',
        label: '08.04. - 01.07. | 13 x 90min | 182€',
      },
      {
        id: '26.08. - 11.11. | 10 x 90min | 140€',
        label: '26.08. - 11.11. | 10 x 90min | 140€',
      },
      {
        id: '18.11. - 16.12. | 5 x 90min | 70€',
        label: '18.11. - 16.12. | 5 x 90min | 70€',
      },
    ],
  },
  {
    title: 'Donnerstagskurs',
    id: 'Donnerstagskurs',
    for: 'Donnerstag',
    options: [
      {
        id: '08.01. - 19.03. | 10 x 90min | 130€',
        label: '08.01. - 19.03. | 10 x 90min | 130€',
      },
      {
        id: '09.04. - 25.06. | 11 x 90min | 154€',
        label: '09.04. - 25.06. | 11 x 90min | 154€',
      },
      {
        id: '13.08. - 05.11. | 10 x 90min | 140€',
        label: '13.08. - 05.11. | 10 x 90min | 140€',
      },
      {
        id: '12.11. - 17.12. | 6 x 90min | 84€',
        label: '12.11. - 17.12. | 6 x 90min | 84€',
      },
    ],
  },
  {
    title: 'Freitagskurs',
    id: 'Freitagskurs',
    for: 'Freitag',
    options: [
      {
        id: '09.01. - 20.03. | 10 x 90min | 130€',
        label: '09.01. - 20.03. | 10 x 90min | 130€',
      },
      {
        id: '10.04. - 26.06. | 10 x 90min | 140€',
        label: '10.04. - 26.06. | 10 x 90min | 140€',
      },
      {
        id: '14.08. - 06.11. | 10 x 90min | 140€',
        label: '14.08. - 06.11. | 10 x 90min | 140€',
      },
      {
        id: '13.11. - 18.12. | 6 x 90min | 84€',
        label: '13.11. - 18.12. | 6 x 90min | 84€',
      },
    ],
  },
  {
    title: 'Ferienangebot',
    id: 'Ferienangebot',
    for: 'Mittwoch',
    options: [
      {
        id: '12.08. | 18:30 - 20:00 | 1 x 90min | 14€',
        label: '12.08. | 18:30 - 20:00 | 1 x 90min | 14€',
      },
    ],
  },
]
